import { useEffect, useReducer } from 'react';
import HorseSelector from './HorseSelector';
import { horseService } from './HorseService.js';
import { useForm }  from 'react-hook-form';
// import { useHistory } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/Authcontext';
import { toast } from 'react-toastify';



const initialState = {
    isLoading: false,
    isSubmitting: false,
    serverCommunication: undefined,
    horseId: undefined
}

const ACTIONS = {
    HORSE_CREATE_CALL: 'HORSE_CREATE_CALL',
    HORSE_CREATE_SUCCESS: 'HORSE_CREATE_SUCCESS',
    HORSE_CREATE_ERROR: 'HORSE_CREATE_ERROR'
}

function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.HORSE_CREATE_CALL:
            return {
                ...state,
                isLoading: true
            };
        case ACTIONS.HORSE_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                horseId: action.data.id
            };
        case ACTIONS.HORSE_CREATE_ERROR:
            return {
                ...state,
                isLoading: false,
                isSubmitting: false,
                serverCommunication: action.data
            }
        default:
            throw new Error(`No action of type ${action.type} found in reducer.`)
    }
}


export const breedOptions = [
    "Arabian",
    "Half Arabian",
    "Morgan",
    "Arabian Quarter Horse",
    "Other"
]

function HorseCreate() {

    const {contextValue } = useAuth();


    const [state, dispatch] = useReducer(reducer, initialState);
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    // const history = useHistory();
    const navigate = useNavigate();
    useEffect(() => {
        if (state.horseId) {
            // history.push(`/horse/${state.horseId}`)
            navigate(`/horse/${state.horseId}`);
        }
    }, [state.horseId, navigate]);

    function handleHorseCreate(horse) {

        contextValue.showLoader();
        contextValue.updateLoaderText("Creating discipline...");

        
        dispatch({ type: ACTIONS.HORSE_CREATE_CALL });
        horseService.createHorse({
            ...horse,
            damId: horse.dam?.id,
            sireId: horse.sire?.id
        })

        .then(response => 
            {
                toast.success("Horse created successfully");
                dispatch({ type: ACTIONS.HORSE_CREATE_SUCCESS, data: response.data })
            }
        
        )
        .catch(error =>{
            toast.error("Error creating horse");
            dispatch({ type: ACTIONS.HORSE_CREATE_ERROR, data: error.response.data })
        })
        .finally(() => contextValue.hideLoader());




        // .then(response => dispatch({ type: ACTIONS.HORSE_CREATE_SUCCESS, data: response.data }))
        // .catch(error => dispatch({ type: ACTIONS.HORSE_CREATE_ERROR, data: error}));
    }

    function renderBreedOptions() {
        return breedOptions.map((item) => (
            <option key={`breed${item}`} value={item}>{item}</option>
        ));
    }

    return (
        <form onSubmit={handleSubmit(handleHorseCreate)}>
            <div className='mb-3'>
                <label htmlFor='newHorseName' className='form-label'>Name</label>
                <input type='text' className='form-control' id='newHorseName' autoComplete='off' {...register('name', { required: true })}/>
                {errors.name?.type === 'required' && <div className='text-danger form-text'>Name is required</div>}
            </div>
            <div className='mb-3'>
                <label htmlFor='newHorseRegistrationNumber' className='form-label'>Registration Number</label>
                <input type='text' className='form-control' id='newHorseRegistrationNumber' autoComplete='off' {...register('registrationNumber')}/>
            </div>
            <div className='mb-3'>
                
                <label htmlFor='newHorseBreeder' className='form-label'>Breeder</label>

                <select className='form-select'  id='horseBreedId' autoComplete='off' {...register('BreedId')} > 
                    {renderBreedOptions()}
                </select>


                {/* <input type='text' className='form-control' id='newHorseBreeder' autoComplete='off' {...register('BreedId')}/> */}
            </div>
            <div className='mb-3'>
                <label htmlFor='newHorseFoalingDate' className='form-label'>Foaling Date</label>
                <input name='foalingDate' type='date' className='form-control' id='newHorseFoalingDate' autoComplete='off' {...register('foalingDate')}/>
            </div>
            <div className='mb-3'>
                <label htmlFor='newHorseSire' className='form-label'>Sire</label>
                <HorseSelector className='form-control' id='newHorseSire' onChange={(value) => setValue('sire', value)}></HorseSelector>
                <div className='form-text'>If the sire does not exist in our database, you will have to create it separately.</div>
            </div>
            <div className='mb-3'>
                <label htmlFor='newHorseDam' className='form-label'>Dam</label>
                <HorseSelector className='form-control' id='newHorseSire' onChange={(value) => setValue('dam', value)}></HorseSelector>
                <div className='form-text'>If the dam does not exist in our database, you will have to create it separately.</div>
            </div>
            {state.serverCommunication && <p className='text-danger'>{state.serverCommunication.messages}</p>}
            <button className='btn btn-success text-white w-100' type='submit'>Create</button>
        </form>
    );
}

export default HorseCreate;